<template>
  <v-container fluid>
    <main-header-plat-a-pat />
    <main-header-plat-b :navBItems="schema.navBItems" />
    <v-overlay-loader />
    <v-row class="mx-auto">
      <v-inbox />
    </v-row>
    <v-snack-bar :snackbar="snackbar" />
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import MainHeaderPlatAPat from '@/components/includes/MainHeaderPlatAPat.vue';
import MainHeaderPlatB from '@/components/includes/MainHeaderPlatB.vue';
import VOverlayLoader from '@/components/base/VOverlayLoader.vue';
import VInbox from '@/components/base/VInbox.vue';
import VSnackBar from '@/components/base/VSnackBar.vue';

export default {
  name: 'PatInboxPage',
  components: {
    MainHeaderPlatAPat,
    MainHeaderPlatB,
    VOverlayLoader,
    VInbox,
    VSnackBar,
  },
  props: ['dialogItem'],
  data() {
    return {
      overlay: false,
      overlayProgress: false,
    };
  },
  mounted() {
    this.loadSchema();
    this.loadRecordHCP();
    this.loadRecordProfes();
    this.loadRecordTransfers();
  },
  computed: {
    ...mapGetters('patRecordAPage', [
      'schema',
      'recordHCP',
      'recordProfes',
      'recordTransfers',
      'codeTransfer',
    ]),
    ...mapGetters('notifications', ['snackbar']),
  },
  methods: {
    ...mapActions('patRecordAPage', [
      'loadSchema',
      'loadRecordHCP',
      'loadRecordProfes',
      'loadRecordTransfers',
      'saveTransfer',
    ]),
    ...mapActions('notifications', ['triggerSnackbar']),

    handleEvents() {},
    updateInput(modelRecordHCPInput) {
      this.modelRecordHCPInput = modelRecordHCPInput;
    },
    updateInputProfes(modelRecordProfesInput) {
      this.modelRecordProfesInput = modelRecordProfesInput;
    },
    async saveTransfer() {
      this.overlayProgress = true;

      let recordHCP = this.recordHCP;
      let modelRecordHCPInputPre = this.modelRecordHCPInput;
      const modelRecordProfesInput = this.modelRecordProfesInput;

      let recordHCPNum = [];
      for (let i = 0; i < recordHCP.length; i++) {
        if (parseInt(recordHCP[i].instProfes) === modelRecordProfesInput) {
          recordHCPNum.push(recordHCP[i].id);
        }
      }

      for (let i = 0; i < recordHCPNum.length; i++) {
        for (let n = 0; n < modelRecordHCPInputPre.length; n++) {
          if (
            recordHCPNum[i] <= modelRecordHCPInputPre[n] &&
            modelRecordHCPInputPre[n] <= recordHCPNum[i] + 27
          ) {
            delete modelRecordHCPInputPre[n];
          }
        }
      }

      let modelRecordHCPInput = modelRecordHCPInputPre.filter(function (el) {
        return el != null;
      });

      let model = {};
      model.recordHCP = recordHCP;
      model.modelRecordHCPInput = modelRecordHCPInput;
      model.modelRecordProfesInput = modelRecordProfesInput;
      model.id = this.$store.state.authPat.authData.patientId;

      this.$store.dispatch('patRecordAPage/saveTransfer', { model }).then(
        () => {
          this.reload();
          this.overlayProgress = false;
          this.toggleOverlay();
          this.snackbar.content = this.schema.snackOk;
        },
        () => {
          this.reload();
          this.snackbar.content = this.schema.snackError;
        }
      );
    },
    toggleOverlay() {
      if (this.overlay === false) {
        this.overlay = true;
      } else {
        this.overlay = false;
      }
    },
    reload() {
      this.loadSchema();
      this.loadRecordHCP();
      this.loadRecordProfes();
      this.loadRecordTransfers();
    },
  },
};
</script>

<style>
.barLateral {
  min-width: 60px;
}

.contentCentral {
  width: 96%;
}

.contentCardCentral {
  width: 98.5%;
  margin-top: 90px;
}

.contentRowCentral {
  width: 80%;
  min-height: 400px;
}

.bannerAction {
  width: 87%;
  height: 48px;
}
</style>
